import React, { useState, useEffect } from 'react';
import { toast } from 'sonner';
import api from '../../api';
import { useGlobalContext } from '../../context';
import ReactDataTable from '../components/ReactDataTable';
import SideNav from '../components/SideNav';
import adminDashLinks from './adminDashLinks';

import { AiOutlineClose } from "react-icons/ai";
import { GiHamburgerMenu } from "react-icons/gi";
import { BiLogOut } from "react-icons/bi";
import ConfirmModal from '../components/ConfirmModal';

const AdminDeposits = () => {
  const { allUsersDepData, allUsersMongoData } = useGlobalContext();

  const [navActive, updateNavActive] = useState(null);
  const [confirm, setConfirm] = useState(null);

  const askConfirm = (title, message, onConfirm) => {
    setConfirm({ title, message, onConfirm });
  };

  const clearSess = async () => {
    try { await api.post('/api/logout'); } catch (e) {}
    window.sessionStorage.clear();
  };

  const hideNav = () => updateNavActive(false);

  useEffect(() => {
    if (navActive) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [navActive]);

  // update deposit
  const [activedepForm, updateactiveDepForm] = useState(null);
  const [depositForm, UpdateDepForm] = useState({ userId: "", depositAmount: "", depositType: "" });

  const depositSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await api.post('/api/admin/updatedeposit', { ...depositForm });
      const responseData = response.data;
      if (responseData.errMsg) {
        toast.error(responseData.errMsg);
      } else {
        toast.success(responseData.successMsg);
        updateactiveDepForm(false);
        UpdateDepForm({ userId: "", depositAmount: "", depositType: "" });
        setTimeout(() => window.location.reload(), 5000);
      }
    } catch (error) { console.log(error); }
  };

  // update profit
  const [ProfField, updateProfField] = useState(null);
  const [ProfForm, UpdateProfForm] = useState({ userId: "", profamount: "" });

  const profSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await api.post('/api/admin/updateprof', { ...ProfForm });
      const responseData = response.data;
      updateProfField(false);
      if (responseData.errMsg) {
        toast.error(responseData.errMsg);
      } else {
        toast.success(responseData.successMsg);
        setTimeout(() => window.location.reload(), 5000);
      }
    } catch (error) { console.log(error); }
  };

  // update bonus
  const [BonusField, updateBonusField] = useState(null);
  const [BonusForm, UpdateBonusForm] = useState({ userId: "", BonusAmount: "" });

  const bonusSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await api.post('/api/admin/updatebonus', { ...BonusForm });
      const responseData = response.data;
      updateBonusField(false);
      if (responseData.errMsg) {
        toast.error(responseData.errMsg);
      } else {
        toast.success(responseData.successMsg);
        setTimeout(() => window.location.reload(), 5000);
      }
    } catch (error) { console.log(error); }
  };

  // delete deposit
  const deleteDeposit = async (userId) => {
    try {
      const response = await api.delete('/api/admin/deletedeposit', { data: { userId } });
      toast.success(response.data.successMsg);
      setTimeout(() => window.location.reload(), 5000);
    } catch (error) { console.log(error); }
  };

  const columns = [
    {
      name: 'Date',
      selector: (row) => row.date,
      cell: (row) => <div style={{ whiteSpace: 'normal' }}>{new Date(row.date).toLocaleDateString('en-GB')}</div>,
    },
    {
      name: 'Email',
      selector: row => row.depemail,
      cell: (row) => <div style={{ whiteSpace: 'normal' }}>{row.depemail}</div>,
    },
    {
      name: 'Amount',
      selector: row => row.depamnt,
      cell: (row) => <div style={{ whiteSpace: 'normal' }}>${parseFloat(row.depamnt).toLocaleString()}</div>,
    },
    {
      name: 'Type',
      selector: row => row.deptype,
      cell: (row) => <div style={{ whiteSpace: 'normal' }}>{row.deptype}</div>,
    },
    {
      name: 'Status',
      selector: row => row.depstatus,
      cell: (row) => <div style={{ whiteSpace: 'normal' }}>{row.depstatus}</div>,
    },
    {
      name: 'Action',
      cell: (row) => (
        <div style={{ whiteSpace: 'normal', display: 'flex', alignItems: 'center' }}>
          <button onClick={() => askConfirm('Delete Deposit', 'Delete this deposit record?', () => deleteDeposit(row._id))} className="bg-red-700 text-white flex justify-center items-center min-w-[60px] h-[28px] rounded-lg px-2 text-[12px]">Delete</button>
        </div>
      ),
    },
  ];

  const modalClass = "fixed w-full min-h-full top-0 left-0 flex justify-center items-center bg-black/80 z-50";
  const modalInner = "relative w-[90%] flex flex-col justify-start items-start space-y-5 bg-[#181C26] border border-[#1f2535] p-6 rounded-xl sm:w-[420px]";
  const inputClass = "bg-[#0d1017] px-3 border border-[#1f2535] rounded-lg w-full h-[45px] text-white text-[16px] focus:outline-none focus:border-[#473ECD] transition-colors";
  const labelClass = "text-[11px] text-[#A9ABAD] uppercase tracking-widest";
  const submitClass = "w-full min-h-[44px] flex justify-center items-center text-[14px] font-[500] bg-userDashPurple text-white rounded-lg transition-all ease-in duration-200 hover:bg-[#3d34b5]";

  return (
    <div className="absolute overflow-x-hidden w-full min-h-full text-white bg-black">
      <SideNav
        hideNav={hideNav}
        logout="/signin"
        logoutBtn={clearSess}
        translateAction={navActive ? `translate-x-[0px]` : `translate-x-[-500px]`}
        backgroundColor="bg-black"
        iconBorderColor="border-black"
        iconBgColor="bg-inherit"
        textColor="text-white"
        links={adminDashLinks}
        logouticon={
          <BiLogOut className="cursor-pointer text-[20px] text-white transition-all ease-in duration-300 hover:scale-[1.1]" />
        }
      />

      {navActive && (
        <div className="fixed inset-0 bg-black/60 z-40 xl:hidden" onClick={hideNav} />
      )}

      {confirm && (
        <ConfirmModal
          title={confirm.title}
          message={confirm.message}
          onConfirm={() => { confirm.onConfirm(); setConfirm(null); }}
          onCancel={() => setConfirm(null)}
        />
      )}

      {/* Update Deposit Modal */}
      {activedepForm && (
        <div className={modalClass}>
          <div className={modalInner}>
            <div className="w-full flex justify-between items-center">
              <h4 className="text-white font-[600] text-[16px]">Update Deposit</h4>
              <button onClick={() => { updateactiveDepForm(false); UpdateDepForm({ userId: "", depositAmount: "", depositType: "" }); }}>
                <AiOutlineClose className="text-[#A9ABAD] text-[20px] hover:text-white transition-colors" />
              </button>
            </div>
            <form className="w-full flex flex-col space-y-4" onSubmit={depositSubmit}>
              <div className="flex flex-col space-y-2">
                <label className={labelClass}>Select User</label>
                <select name="userId" value={depositForm.userId} className={inputClass} onChange={(e) => UpdateDepForm({ ...depositForm, userId: e.target.value })}>
                  <option value="">-- Select a user --</option>
                  {Array.isArray(allUsersMongoData) && allUsersMongoData.map((user) => (
                    <option key={user._id} value={user.email}>{user.username} — {user.email}</option>
                  ))}
                </select>
              </div>
              <div className="flex flex-col space-y-2">
                <label className={labelClass}>Amount</label>
                <input type="text" name="depositAmount" className={inputClass} onChange={(e) => UpdateDepForm({ ...depositForm, [e.target.name]: e.target.value })} />
              </div>
              <div className="flex flex-col space-y-2">
                <label className={labelClass}>Type</label>
                <select name="depositType" value={depositForm.depositType} className={inputClass} onChange={(e) => UpdateDepForm({ ...depositForm, depositType: e.target.value })}>
                  <option value="">-- Select type --</option>
                  <option value="BTC">BTC</option>
                  <option value="ETH">ETH</option>
                  <option value="USDT (ERC20)">USDT (ERC20)</option>
                  <option value="SOL">SOL</option>
                </select>
              </div>
              <button type="submit" className={submitClass}>Update</button>
            </form>
          </div>
        </div>
      )}

      {/* Update Profit Modal */}
      {ProfField && (
        <div className={modalClass}>
          <div className={modalInner}>
            <div className="w-full flex justify-between items-center">
              <h4 className="text-white font-[600] text-[16px]">Update Profit</h4>
              <button onClick={() => updateProfField(false)}>
                <AiOutlineClose className="text-[#A9ABAD] text-[20px] hover:text-white transition-colors" />
              </button>
            </div>
            <form className="w-full flex flex-col space-y-4" onSubmit={profSubmit}>
              <div className="flex flex-col space-y-2">
                <label className={labelClass}>Select User</label>
                <select name="userId" value={ProfForm.userId} className={inputClass} onChange={(e) => UpdateProfForm({ ...ProfForm, userId: e.target.value })}>
                  <option value="">-- Select a user --</option>
                  {Array.isArray(allUsersMongoData) && allUsersMongoData.map((user) => (
                    <option key={user._id} value={user.email}>{user.username} — {user.email}</option>
                  ))}
                </select>
              </div>
              <div className="flex flex-col space-y-2">
                <label className={labelClass}>Amount</label>
                <input type="text" name="profamount" className={inputClass} onChange={(e) => UpdateProfForm({ ...ProfForm, [e.target.name]: e.target.value })} />
              </div>
              <button type="submit" className={submitClass}>Update</button>
            </form>
          </div>
        </div>
      )}

      {/* Update Bonus Modal */}
      {BonusField && (
        <div className={modalClass}>
          <div className={modalInner}>
            <div className="w-full flex justify-between items-center">
              <h4 className="text-white font-[600] text-[16px]">Update Bonus</h4>
              <button onClick={() => updateBonusField(false)}>
                <AiOutlineClose className="text-[#A9ABAD] text-[20px] hover:text-white transition-colors" />
              </button>
            </div>
            <form className="w-full flex flex-col space-y-4" onSubmit={bonusSubmit}>
              <div className="flex flex-col space-y-2">
                <label className={labelClass}>Select User</label>
                <select name="userId" value={BonusForm.userId} className={inputClass} onChange={(e) => UpdateBonusForm({ ...BonusForm, userId: e.target.value })}>
                  <option value="">-- Select a user --</option>
                  {Array.isArray(allUsersMongoData) && allUsersMongoData.map((user) => (
                    <option key={user._id} value={user.email}>{user.username} — {user.email}</option>
                  ))}
                </select>
              </div>
              <div className="flex flex-col space-y-2">
                <label className={labelClass}>Amount</label>
                <input type="text" name="BonusAmount" className={inputClass} onChange={(e) => UpdateBonusForm({ ...BonusForm, [e.target.name]: e.target.value })} />
              </div>
              <button type="submit" className={submitClass}>Update</button>
            </form>
          </div>
        </div>
      )}

      <div className="relative flex flex-col flex-grow w-full h-full px-4 mb-[100px] xl:pl-[304px] xl:pr-6">
        {/* top nav */}
        <nav className="relative w-full min-h-[100px] flex justify-center items-start pt-3">
          <div className="relative w-full min-h-[50px] flex justify-between items-center xl:justify-end">
            <button onClick={() => updateNavActive(true)} className="relative xl:hidden">
              <GiHamburgerMenu className="text-[20px] text-[#A9ABAD]" />
            </button>
          </div>
        </nav>

        {/* page header */}
        <div className="relative w-full flex flex-col justify-start items-start space-y-1 pt-4 pb-8">
          <h3 className="text-[20px] font-[600] text-white">Manage Deposits</h3>
          <p className="text-[#A9ABAD] text-[14px]">View and update user deposit records.</p>
        </div>

        {/* action buttons */}
        <div className="flex flex-wrap gap-3 pb-8">
          <button onClick={() => updateactiveDepForm(true)} className="min-h-[38px] px-4 flex justify-center items-center text-[13px] font-[500] bg-[#181C26] border border-[#1f2535] text-white rounded-lg hover:border-[#473ECD] transition-colors">
            Update Deposit
          </button>
          <button onClick={() => updateProfField(true)} className="min-h-[38px] px-4 flex justify-center items-center text-[13px] font-[500] bg-[#181C26] border border-[#1f2535] text-white rounded-lg hover:border-[#473ECD] transition-colors">
            Update Profit
          </button>
          <button onClick={() => updateBonusField(true)} className="min-h-[38px] px-4 flex justify-center items-center text-[13px] font-[500] bg-[#181C26] border border-[#1f2535] text-white rounded-lg hover:border-[#473ECD] transition-colors">
            Update Bonus
          </button>
        </div>

        {/* table */}
        <div className="relative w-full overflow-x-auto">
          <ReactDataTable columns={columns} data={allUsersDepData} />
        </div>
      </div>
    </div>
  );
};

export default AdminDeposits;
